import createSignatureBlock from './createSignatureBlock';
import { ComposeViewState, ComposeOperation } from 'owa-mail-compose-store';
import { lazyOperateContent } from 'owa-editor';
import { ContentPosition } from 'roosterjs-editor-types';
import { ComposeType } from 'owa-editor-addin-plugin-types/lib/utils/AddinViewState';
import { Signature } from 'owa-mail-signature/lib/store/schema/SignatureStore';
import { isFeatureEnabled } from 'owa-feature-flags';

export default async function insertSignature(
    viewState: ComposeViewState,
    signature?: string,
    roamingSignature?: Signature,
    isAutoSignature?: boolean
) {
    const isReplyOrReplyAll =
        viewState.operation == ComposeOperation.Reply ||
        viewState.operation == ComposeOperation.ReplyAll;
    lazyOperateContent.import().then(operateContent =>
        operateContent(
            viewState,
            editor => {
                editor.focus();
                const signatureToInsert = isFeatureEnabled('cmp-roaming-signature')
                    ? roamingSignature?.html?.value
                    : signature;
                if (signatureToInsert != null && signatureToInsert != undefined) {
                    /* This will delete only the node with id "Sigature", it doesn't affest the quoted body
                    beacuse for quoted body, server will change the element id from "Signature" to "x_Signature" */
                    editor.queryElements('#Signature', signatureNode => {
                        editor.deleteNode(signatureNode);
                    });
                }

                editor.insertContent(
                    createSignatureBlock(
                        'HTML',
                        false /* isAutoSignature */,
                        signatureToInsert,
                        isReplyOrReplyAll
                    ),
                    {
                        position:
                            isAutoSignature ||
                            (signature != null &&
                                signature != undefined &&
                                (viewState.isInlineCompose ||
                                    viewState.addin.draftComposeType == ComposeType.New))
                                ? ContentPosition.End
                                : ContentPosition.SelectionStart,
                        updateCursor: false,
                        replaceSelection: true,
                        insertOnNewLine: true,
                    }
                );
                return {
                    selectionRange: editor.getSelectionRange(),
                    changeSource: 'Signature',
                };
            },
            (content, selectionStart, selectionEnd) => {
                const signatureToInsert = isFeatureEnabled('cmp-roaming-signature')
                    ? roamingSignature.txt.value
                    : signature;
                return {
                    value:
                        content.substr(0, selectionEnd) +
                        createSignatureBlock(
                            'Text',
                            false /* isAutoSignature */,
                            signatureToInsert,
                            isReplyOrReplyAll
                        ) +
                        content.substr(selectionEnd),
                    selectionStart,
                    selectionEnd,
                    focus: true,
                };
            }
        )
    );
}
